// Our main CSS
import '../css/app.css'
import { ModuleManager } from './moduleManager'


// Create and configure module manager
const moduleManager = new ModuleManager()

// Register all modules with their selectors
moduleManager
  .register('.marquee-holder', 'marquee')
  .register('.js-swiper-services', 'serviceSlider')
  .register('.js-faq', 'faq')
  .register('.js-job-form', 'jobForm')
  .register('.js-clean-form', 'cleanForm')
  .register('.js-offer-form', 'offerForm')
  .register('.js-regular-form', 'regularForm')
  .register('.js-newsletter', 'newsForm')
  .register('.js-single-job-form', 'singleJobForm')




  .registerAdmin('Marquee', 'marquee')
  .registerAdmin('ServiceSlider', 'serviceSlider')
  .registerAdmin('Faq', 'faq')
  .registerAdmin('JobForm', 'jobForm')
  .registerAdmin('CleanForm', 'cleanForm')
  .registerAdmin('OfferForm', 'offerForm')
  .registerAdmin('RegularForm', 'regularForm')
  .registerAdmin('SingleJobForm', 'singleJobForm')


// Initialize modules
moduleManager.init()


// Create initializer functions on window object
Object.keys(moduleManager.adminModules).forEach(name => {
  const modulePath = moduleManager.adminModules[name]
  window[`init${name}`] = () => moduleManager.loadModule(modulePath)
})
/**
 * 🦄: Now do your magic.
 */


const menuToggles = document.querySelectorAll('.menu-toggle');
const overlayMenu = document.querySelector('.overlay-menu');

// Handler for menu toggle clicks
const toggleOverlayMenu = () => {
  overlayMenu.classList.toggle('visible');
  const isVisible = overlayMenu.classList.contains('visible');

  if (isVisible) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
};

menuToggles.forEach((toggle) => {
  toggle.addEventListener('click', toggleOverlayMenu);
});